import React from "react";
import CustomScrollbars from './CustomScrollbars/CustomScrollbars';

export default class Popover extends React.Component {

    constructor(props){

        super(props);
        this.state = {
            isShown: false
        };
        this.setRef = this.setRef.bind(this);
        this.handleOuterClick = this.handleOuterClick.bind(this);
    }

    toggle() {

        this.setState({
                        isShown: !this.state.isShown
                      });
    }

    handleOuterClick(event) {

        if (this.ref && !this.ref.contains(event.target)) {
            this.setState({
                isShown: false
            });
        }
    }

    setRef(node) {
        this.ref = node;
    }

    componentDidMount() {

        (this.props.document || document).addEventListener('click', this.handleOuterClick);
    }

    componentWillUnmount() {

        (this.props.document || document).removeEventListener('click', this.handleOuterClick);
    }

    render() {

        const toggleText = this.props.toggleText;
        const title = this.props.title;
        const content = this.props.content;
        const top = (this.props.top) ? this.props.top : 'auto';
        const left = (this.props.left) ? this.props.left : 'auto';
        const right = (this.props.right) ? this.props.right : 'auto';
        const bottom = (this.props.bottom) ? this.props.bottom : 'auto';
        const style = {top, left, right, bottom};

        return (
            <div ref={this.setRef} className="amt-popover" onClick={() => this.toggle()}>
                <div className="amt-popover-toggle">{toggleText}</div>
                { this.state.isShown ?
                    <div className="amt-popover-content" style={style}>
                        <CustomScrollbars style={{ width: "100%", height: 200 }} document={this.props.document}>
                            <div className="amt-popover-content-wrap">
                                <div className="amt-popover-title">{title}</div>
                                <div>{content}</div>
                            </div>
                        </CustomScrollbars>
                    </div> :
                  null
                }
            </div>
        );
    }
}